export const ButtonsBindings = parent => {
    parent.copyIssueProfile = parent.copyIssueProfile.bind(parent);
    parent.displayIssueProfile = parent.displayIssueProfile.bind(parent);
    parent.editIssueProfile = parent.editIssueProfile.bind(parent);
    parent.deleteIssueProfile = parent.deleteIssueProfile.bind(parent);
};
